import { create } from 'zustand';
/** The Assist rail survives a refresh: whether it is open, the route it was
 *  opened from and the conversation it holds are kept for this tab. */ const ASSIST_KEY = 'specra.assist-rail';
function readAssist() {
    const none = {
        open: false,
        origin: null,
        chatId: null
    };
    try {
        const raw = globalThis.sessionStorage?.getItem(ASSIST_KEY);
        if (!raw) return none;
        const v = JSON.parse(raw);
        return {
            open: v.open === true,
            origin: typeof v.origin === 'string' ? v.origin : null,
            chatId: typeof v.chatId === 'string' ? v.chatId : null
        };
    } catch  {
        return none;
    }
}
function saveAssist(v) {
    try {
        globalThis.sessionStorage?.setItem(ASSIST_KEY, JSON.stringify(v));
    } catch  {
    // private mode or quota: the rail just won't survive a refresh
    }
}
const savedAssist = readAssist();
export const useLayoutStore = create((set, get)=>{
    const persistAssist = (patch)=>{
        const s = get();
        saveAssist({
            open: s.assistOpen,
            origin: s.assistOrigin,
            chatId: s.assistChatId,
            ...patch
        });
    };
    return {
        pageHeaderContent: null,
        setPageHeaderContent: (content)=>set({
                pageHeaderContent: content
            }),
        clearPageHeaderContent: ()=>set({
                pageHeaderContent: null
            }),
        showBreadcrumbs: true,
        setShowBreadcrumbs: (show)=>set({
                showBreadcrumbs: show
            }),
        showHeader: true,
        setShowHeader: (show)=>set({
                showHeader: show
            }),
        breadcrumbItems: null,
        setBreadcrumbItems: (items)=>set({
                breadcrumbItems: items
            }),
        assistOpen: savedAssist.open,
        assistHost: 'rail',
        setAssistHost: (host)=>set({
                assistHost: host
            }),
        // Closing the rail by any path (close button, ⌘J, header toggle) drops
        // the pinned conversation, so reopening follows the route again.
        setAssistOpen: (open)=>{
            const patch = open ? {
                open
            } : {
                open,
                chatId: null
            };
            persistAssist(patch);
            set(open ? {
                assistOpen: true
            } : {
                assistOpen: false,
                assistChatId: null
            });
        },
        toggleAssist: ()=>{
            const open = !get().assistOpen;
            persistAssist(open ? {
                open
            } : {
                open,
                chatId: null
            });
            set(open ? {
                assistOpen: true
            } : {
                assistOpen: false,
                assistChatId: null
            });
        },
        assistOrigin: savedAssist.origin,
        setAssistOrigin: (path)=>{
            persistAssist({
                origin: path
            });
            set({
                assistOrigin: path
            });
        },
        assistChatId: savedAssist.chatId,
        setAssistChatId: (id)=>{
            persistAssist({
                chatId: id
            });
            set({
                assistChatId: id
            });
        },
        sidebarCollapsed: false,
        setSidebarCollapsed: (collapsed)=>set({
                sidebarCollapsed: collapsed
            }),
        toggleSidebarCollapsed: ()=>set((s)=>({
                    sidebarCollapsed: !s.sidebarCollapsed
                })),
        chatRailCollapsed: false,
        setChatRailCollapsed: (collapsed)=>set({
                chatRailCollapsed: collapsed
            }),
        toggleChatRailCollapsed: ()=>set((s)=>({
                    chatRailCollapsed: !s.chatRailCollapsed
                }))
    };
});
